'use client';

import { useEffectOnce } from '@carvana/merch-react-hooks';
import React from 'react';
import useSetDataDogContext from '~/hooks/dealership/useSetDataDogContext';
import initDataDog from '~/utilities/datadog';

type AppProps = {
  correlationId: string;
  dealershipId: string;
};

type OwnProps = React.PropsWithChildren<{
  appProps: AppProps;
}>;

export default function ForAppWrapper({ children, appProps }: OwnProps) {
  useSetDataDogContext(appProps.dealershipId);

  useEffectOnce(() => {
    initDataDog(appProps.correlationId);
  }, [appProps.correlationId]);

  return <>{children}</>;
}
